import base from '../dr-base'
import drImage from './dr-image.vue'

const schema = {
  $Type: 'dr-image',
  name: 'Image',
  group: 'Common widgets',
  icon: 'image-polaroid',
  ...base,
  properties: {
    ...base.properties,
    ImageUrl: {
      name: 'vuetifyWidgets.dr-image.imageUrl',
      type: 'string',
      default: 'https://picsum.photos/510/300?random1',
      component: 'dr-value-editor'
    },
    DefaultImage: {
      name: 'vuetifyWidgets.dr-image.defaultImage',
      type: 'string',
      component: 'dr-value-editor'
    },
    Width: {
      name: 'vuetifyWidgets.dr-image.width',
      type: 'string'
    },
    Height: {
      name: 'vuetifyWidgets.dr-image.height',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drImage
}
